import PropTypes from 'prop-types';
import React, {useEffect, useRef} from 'react';
import {
  septemberPromoTrendingBannerControlEligible,
  septemberPromoTrendingBannerTestEligible
} from '../../utils/ab_tests/septemberPromoBannerTest';
import {
  EVENT_TYPE,
  fireSeptemberPromoEvent
} from '../../utils/metrics/septemberPromoBanner';
import SeptemberPromoTrendingBanner from './SeptemberPromoTrendingBanner';
import TrendingProductsCarousel from './TrendingProductsCarousel';

const SeptemberPromoWrapper = ({categoryId}) => {
  const eventFired = useRef(false);
  const isTestVariant = septemberPromoTrendingBannerTestEligible(categoryId);
  const isControlVariant =
    septemberPromoTrendingBannerControlEligible(categoryId);

  const targetVariant = () => {
    if (isTestVariant) return 'test';
    if (isControlVariant) return 'control';
    return null;
  };

  useEffect(() => {
    const variant = targetVariant();
    if (!eventFired.current) {
      window.dataLayer = window.dataLayer || [];
      if (variant) {
        fireSeptemberPromoEvent({
          abTestVariant: variant,
          eventType: EVENT_TYPE.AB_TEST
        });
      }
      eventFired.current = true;
    }
  }, []);

  if (septemberPromoTrendingBannerTestEligible(categoryId)) {
    return <SeptemberPromoTrendingBanner />;
  }
  if (septemberPromoTrendingBannerControlEligible(categoryId)) {
    return <TrendingProductsCarousel />;
  }
  return <div />;
};

SeptemberPromoWrapper.propTypes = {
  categoryId: PropTypes.number
};

export default SeptemberPromoWrapper;
